import useSWRImmutable from 'swr/immutable';

import { ShipmentModel } from '@/lib/models/shipment/types';
import { AsyncDataInterface } from '@/types/context-types';
import { request } from '@/utils/api/request';
import { getMyShipmentsUrl } from '@/utils/helpers/api-urls';

const REFRESH_INTERVAL = 1000 * 60 * 60; // 1 hour

export interface MyShipmentsApiResponse {
  shipments: ShipmentModel[];
}

interface MyShipments extends AsyncDataInterface, MyShipmentsApiResponse {}

interface UseMyShipmentsProps {
  ids: string[];
  includeCreatedByMe?: boolean;
  limit?: number;
}

const ERROR_MESSAGE = 'Error fetching shipments';

export const useMyShipments = ({ ids, includeCreatedByMe, limit = 24 }: UseMyShipmentsProps): MyShipments => {
  const url =
    ids.length || includeCreatedByMe
      ? `${getMyShipmentsUrl()}?ids=${ids.join(',')}&limit=${limit}${includeCreatedByMe ? '&includeCreatedByMe=true' : ''}`
      : null;

  const { data, isLoading, error } = useSWRImmutable<MyShipmentsApiResponse>(url, request, {
    revalidateOnFocus: false,
    errorRetryCount: 1,
    refreshInterval: REFRESH_INTERVAL,
  });

  const errorMessage = error ? ERROR_MESSAGE : undefined;

  return { shipments: data?.shipments || [], isLoading, error: errorMessage };
};
